/* eslint-disable */
/**
 * The path of the `DashboardPage` to be consumed by a `<Router />`
 * @export
 */
export const DASHBOARD_PAGE_PATH = `/`;

/**
 * Create a `href` that will resolve to `DashboardPage`
 * @export
 * @returns {string} The `DASHBOARD_PAGE_PATH`
 */
export const createDashboardPageLink = () => DASHBOARD_PAGE_PATH;

/**
 * Determine if the current page is the `DashboardPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `DashboardPage`
 */
export const isDashboardPage = (match) => match.path === DASHBOARD_PAGE_PATH;
